import { useState } from "react";

import { RoleGate } from "@/components/RoleGate";
import { useCriarLocal, useLocais, useUnidades } from "@/hooks/useApi";
import type { Categoria, TipoLocal } from "@/types/api";

export function LocaisPage() {
  return (
    <RoleGate allowed={["admin", "auditor"]}>
      <Inner />
    </RoleGate>
  );
}

function Inner() {
  const { data: locais, isLoading } = useLocais();
  const { data: unidades } = useUnidades();
  const criar = useCriarLocal();
  const [form, setForm] = useState<{
    codigo: string;
    descricao: string;
    tipo: TipoLocal;
    unidade_id: string;
    categoria_padrao: Categoria | "";
  }>({
    codigo: "",
    descricao: "",
    tipo: "enfermagem",
    unidade_id: "",
    categoria_padrao: "",
  });

  async function handleSubmit() {
    await criar.mutateAsync({
      codigo: form.codigo,
      descricao: form.descricao,
      tipo: form.tipo,
      unidade_id: form.unidade_id,
      categoria_padrao: (form.categoria_padrao || null) as Categoria | null,
    });
    setForm({ ...form, codigo: "", descricao: "" });
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-semibold">Locais de estoque</h2>
        <p className="text-sm text-ink-muted">
          Farmácias e enfermagens dentro das unidades. Sabrina edita aqui quando precisa
          adicionar/remover um subestoque (ex: criar Enfermagem Pediatria no futuro).
        </p>
      </div>

      <div className="card p-4">
        <h3 className="font-display text-base font-semibold">Novo local</h3>
        <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-3">
          <input className="input" placeholder="código (ex: enfermagem_pediatria)"
            value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value })} />
          <input className="input" placeholder="descrição"
            value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
          <select className="input" value={form.tipo}
            onChange={(e) => setForm({ ...form, tipo: e.target.value as TipoLocal })}>
            <option value="enfermagem">Enfermagem</option>
            <option value="farmacia">Farmácia</option>
            <option value="armario_psicotropicos">Armário de Psicotrópicos</option>
            <option value="caixa_anestesia">Caixa de Anestesia</option>
            <option value="caixa_psicotropicos">Caixa de Psicotrópicos</option>
            <option value="carrinho_parada">Carrinho de Parada</option>
          </select>
          <select className="input" value={form.unidade_id}
            onChange={(e) => setForm({ ...form, unidade_id: e.target.value })}>
            <option value="">— escolha unidade —</option>
            {unidades?.map((u) => (
              <option key={u.id} value={u.id}>
                {u.nome}
              </option>
            ))}
          </select>
          <select className="input" value={form.categoria_padrao}
            onChange={(e) => setForm({ ...form, categoria_padrao: e.target.value as Categoria | "" })}>
            <option value="">— sem categoria default —</option>
            <option value="ordinario">Ordinário</option>
            <option value="alto_custo">Alto custo</option>
            <option value="estoque_obrigatorio">Estoque obrigatório</option>
          </select>
        </div>
        <div className="mt-3">
          <button
            className="btn-primary"
            disabled={!form.codigo || !form.descricao || !form.unidade_id || criar.isPending}
            onClick={handleSubmit}
          >
            {criar.isPending ? "Salvando…" : "Adicionar"}
          </button>
        </div>
      </div>

      {isLoading ? <p className="text-ink-muted">Carregando…</p> : null}
      {locais ? (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-ink-muted">
              <tr>
                <th className="px-4 py-3">Código</th>
                <th className="px-4 py-3">Descrição</th>
                <th className="px-4 py-3">Tipo</th>
                <th className="px-4 py-3">Unidade</th>
                <th className="px-4 py-3">Categoria padrão</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {locais.map((l) => {
                const u = unidades?.find((x) => x.id === l.unidade_id);
                return (
                  <tr key={l.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 font-mono text-xs">{l.codigo}</td>
                    <td className="px-4 py-2">{l.descricao}</td>
                    <td className="px-4 py-2 text-ink-muted">{l.tipo}</td>
                    <td className="px-4 py-2 text-ink-muted">{u?.nome ?? "—"}</td>
                    <td className="px-4 py-2">
                      {l.categoria_padrao ? (
                        <span className={l.categoria_padrao === "alto_custo" ? "badge-alto-custo" : "badge-ordinario"}>
                          {l.categoria_padrao}
                        </span>
                      ) : "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
